
import moment from 'moment';
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { Connection, Iter } from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditIterAcceptanceDialog from '@/components/EditIterAcceptanceDialog.vue';
import IterMixin from '@/mixins/IterMixin.vue';

moment.locale('it');

@Component({
  components: {
    EditIterAcceptanceDialog,
  },
})
export default class ConnectionIter extends Mixins(UtilsMixin, IterMixin) {
  @Prop(Object) readonly connection: Connection | null | undefined;

  loading = false
  editDialog = false

  get iter(): Iter | null {
    return this.connection?.iter ?? null;
  }

  get iterAcceptance(): boolean {
    return this.connection?.iterAcceptance === true;
  }

  get iterSelected(): boolean {
    return this.iter !== null;
  }

  get tooltipText(): string {
    if (!this.connection) return '';
    if (!this.iterSelected) return 'Non selezionato';

    return this.iterAcceptance
      ? `${this.iterDescription(this.iter)}`
      : `${this.iterDescription(this.iter)} (da accettare)`;
  }

  get tooltipColor(): string {
    if (!this.connection) return '';
    if (!this.iterSelected) return '';

    return this.iterAcceptance ? 'success' : 'warning';
  }

  get isDisabled() {
    return this.loading;
  }

  get columnClass(): string {
    // Se l'iter non è selezionato, lo sfondo resta bianco
    if (!this.iterSelected) return '';

    // Se la Connection è completata, lo sfondo è verde
    if (this.connection?.status === 'resolved') return 'green';

    return this.iterAcceptance ? 'green' : 'yellow';
  }

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.isDisabled) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}

